import { render } from "./createGift.vue?vue&type=template&id=1dac7fab&scoped=true"
import script from "./createGift.vue?vue&type=script&lang=js"
export * from "./createGift.vue?vue&type=script&lang=js"

import "./createGift.vue?vue&type=style&index=0&id=1dac7fab&lang=less"
import "./createGift.vue?vue&type=style&index=1&id=1dac7fab&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dac7fab"]])

export default __exports__